export default __webpack_public_path__ + "static/media/registroExitoso.d24c69bd.png";